import 'mlmi-library'
import Burger from 'mlmi-library/components/burger/v1/burger'
import Mobile from 'mlmi-library/modules/mobile/v1/mobile'
import Scrollbar from 'mlmi-library/components/scrollbar/v1/scrollbar'
import Tabs from 'mlmi-library/components/tabs/v1/tabs'
import Popup from 'mlmi-library/components/popup/v1/popup'
import Carousel, { Carousel_CoreInit } from 'mlmi-library/components/carousel/v1/carousel'
import Form from 'mlmi-library/components/form/v1/form'
import 'mlmi-library/modules/scroll-events/v1/scroll-events'
import 'mlmi-library/plugins/scroll-to'
import 'mlmi-library/plugins/submenu-parent'
import 'mlmi-library/components/fixed-content/v1/fixed-content'
import { TRANSITION_END } from 'mlmi-library/utils/animation'
import { getCookie, setCookie } from 'mlmi-library/utils/cookies'
import { CoreDetect_WebP } from 'mlmi-library/utils/device'
import 'jquery.easing'

export { Burger, Mobile, Tabs, Carousel, Form, Popup, TRANSITION_END, getCookie, setCookie, Carousel_CoreInit, Scrollbar }

CoreDetect_WebP()
